import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import './style.scss';
import { ForumThreadShape } from 'entities';
import { getForumThreadsGrouped, getForumPaging } from 'selectors';
import ForumThreadsList from 'containers/ForumThreadsList';
import ForumThread from 'containers/ForumThreadsList/ForumThread';
import NoEntries from 'components/NoEntries';
import NoEntriesDetail from 'components/NoEntries/NoEntriesDetail';
import * as actions from 'actions';

class ForumLiveThreadsList extends Component {

  componentDidMount() {
    this.props.onDidMount && this.props.onDidMount();
  }

  renderNoForumThreads() {
    return (
      <NoEntries title={__('members.forum.noThreads.title')}>
        <NoEntriesDetail>{__('members.forum.noThreads.subtitle')}</NoEntriesDetail>
      </NoEntries>
    );
  }

  renderCurrentlyLiveForumThreads() {
    return this.props.currentlyLiveForumThreads.map(
      forumThread => {
        const endDate = moment(forumThread.liveEnd).fromNow();
        return (
          <ForumThread
            isLive
            key={forumThread.id}
            forumThread={forumThread}
            timeInfo={`Ends ${endDate}`}
          />
        );
      }
    );
  }

  renderStartingSoonForumThreads() {
    return this.props.startingSoonForumThreads.map(
      forumThread => {
        const startDate = moment(forumThread.liveStart).fromNow();
        return (
          <ForumThread
            key={forumThread.id}
            forumThread={forumThread}
            timeInfo={`Starts ${startDate}`}
          />
        );
      }
    );
  }

  renderEndedForumThreads() {
    return this.props.endedForumThreads.map(
      forumThread => {
        const endedDate = moment(forumThread.liveEnd).fromNow();
        return (
          <ForumThread
            key={forumThread.id}
            forumThread={forumThread}
            timeInfo={`Ended ${endedDate}`}
          />
        );
      }
    );
  }

  renderLoadingForumThreadsList() {
    return (
      <ForumThreadsList title={__('members.forum.titles.currentlyLive')}>
        <ForumThread key="loader1" isEmpty />
        <ForumThread key="loader2" isEmpty />
        <ForumThread key="loader3" isEmpty />
      </ForumThreadsList>
    );
  }

  renderCurrentlyLiveOrStartingSoonForumThreadsList() {
    return (
      <ForumThreadsList key="liveList" title={__('members.forum.titles.currentlyLive')}>
        {this.renderCurrentlyLiveForumThreads()}
      </ForumThreadsList>
    );
  }

  renderEndedForumThreadsList() {
    return (
      <ForumThreadsList key="recentlyEndedList" title={__('members.forum.titles.recentlyEnded')}>
        {this.renderEndedForumThreads()}
      </ForumThreadsList>
    );
  }

  renderStartingSoonForumThreadsList() {
    return (
      <ForumThreadsList key="rcoomingSoonList" title={__('members.forum.titles.comingSoon')}>
        {this.renderStartingSoonForumThreads()}
      </ForumThreadsList>
    );
  }

  render() {
    return (
      <div className="ForumLiveList has-background has-pagination">
        <div className="wrapper-narrow">

          {(() => {
            const lists = [];

            if(this.props.currentlyLiveForumThreads.length > 0) {
              lists.push(this.renderCurrentlyLiveOrStartingSoonForumThreadsList());
            }

            if(this.props.startingSoonForumThreads.length > 0) {
              lists.push(this.renderStartingSoonForumThreadsList());
            }

            if(this.props.endedForumThreads.length > 0) {
              lists.push(this.renderEndedForumThreadsList());
            }

            if(lists.length > 0) {
              return lists;
            }

            if(this.props.isFetching) {
              return this.renderLoadingForumThreadsList();
            }

            return this.renderNoForumThreads();
          })()}
        </div>
      </div>
    );
  }
}

ForumLiveThreadsList.propTypes = {
  endedForumThreads: PropTypes.arrayOf(ForumThreadShape),
  currentlyLiveForumThreads: PropTypes.arrayOf(ForumThreadShape),
  startingSoonForumThreads: PropTypes.arrayOf(ForumThreadShape),
  isFetching: PropTypes.bool,
  pagesCount: PropTypes.number,
  onFetchCurrentPage: PropTypes.func,
  queryString: PropTypes.string,
  query: PropTypes.object,
  onDidMount: PropTypes.func
};

const query = {live: 'true', pageSize: process.env.KOOTH_MAXIMUM_PAGE_SIZE};
const queryString = JSON.stringify(query);

const mapStateToProps = state => {
  const { page, isFetching, pagesCount } = getForumPaging(state, 'forumThreads', { queryString });

  const {
    endedForumThreads,
    currentlyLiveForumThreads,
    startingSoonForumThreads
  } = getForumThreadsGrouped(state, { page, queryString });

	return {
    endedForumThreads,
    currentlyLiveForumThreads,
    startingSoonForumThreads,
    isFetching,
    queryString,
    query,
    pagesCount
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onDidMount: () => {
      dispatch(actions.forumThreadsFetch(1, query, queryString));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ForumLiveThreadsList);



/** WEBPACK FOOTER **
 ** ./src/members/Main/Forum/ForumLiveThreadsList/index.js
 **/